module.exports = __webpack_public_path__ + "img/1416424635.2ca67fd2.jpg";